import React from 'react';

export const PlaceActionsContext = React.createContext({
  providerEntityAttributes: [],
  onSavePlaceAction: () => {},
  onClearPlaceAction: () => {},
});

export const PlaceActionsContextProvider = PlaceActionsContext.Provider;
